import { useState } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import CreateIcon from '@mui/icons-material/Create';
import ContactsIcon from '@mui/icons-material/Contacts';
import LoginIcon from '@mui/icons-material/Login';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import Contactus from '@mui/icons-material/ContactSupport';
import GrainIcon from '@mui/icons-material/Grain';
import logoImage from '../assets/img/labasservice_white.png';

export default function DefaultNavbar() {
    const [openNavbar, setOpenNavbar] = useState(false);

    return (
        <AppBar position="static" sx={{ bgcolor: 'transparent', boxShadow: 'none' }}>
            <Toolbar>
                <Box 
                    component="img" 
                    src={logoImage}
                    alt="LabAsService Logo"
                    sx={{ 
                        width: { xs: '15%', sm: '20%' }, 
                        height: 'auto',
                        maxWidth: 200,
                        objectFit: 'contain'
                    }}
                />
                <Box sx={{ flexGrow: 1 }} />
                
                <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2, alignItems: 'center' }}>
                    <Link to="/register" style={{ display: 'flex', alignItems: 'center', color: 'white', textDecoration: 'none' }}>
                        <CreateIcon sx={{ mr: 0.5 }} />
                        Register
                    </Link>
                    <Link to="/admin" style={{ display: 'flex', alignItems: 'center', color: 'white', textDecoration: 'none' }}>
                        <LoginIcon sx={{ mr: 0.5 }} />
                        Login
                    </Link>
                    <Link to="https://www.zippyops.com/contact-us" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', color: 'white', textDecoration: 'none' }}>
                        <ContactsIcon sx={{ mr: 0.5 }} />
                        contact Us
                    </Link>
                    <Link to="https://support.zippyops.com/" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', color: 'white', textDecoration: 'none' }}>
                        <Contactus sx={{ mr: 0.5 }} />
                        Support
                    </Link>
                    <Link to="https://www.zippyops.com/" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', color: 'white', textDecoration: 'none' }}>
                        <LibraryBooksIcon sx={{ mr: 0.5 }} />
                        Docs
                    </Link>
                    <Link to="/products" style={{ display: 'flex', alignItems: 'center', color: 'white', textDecoration: 'none' }}>
                        <GrainIcon sx={{ mr: 0.5 }} />
                        Labs Offered
                    </Link>
                </Box>

                <IconButton
                    color="inherit"
                    edge="start"
                    onClick={() => setOpenNavbar(!openNavbar)}
                    sx={{ display: { xs: 'block', md: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>
            </Toolbar>

            <Drawer
                anchor="right"
                open={openNavbar}
                onClose={() => setOpenNavbar(false)}
            >
                <Box sx={{ width: 250, pt: 8 }}>
                    <List>
                        <ListItem button component={Link} to="/register" onClick={() => setOpenNavbar(false)}>
                            <CreateIcon sx={{ mr: 1 }} />
                            <ListItemText primary="Register" />
                        </ListItem>
                        <ListItem button component={Link} to="/admin" onClick={() => setOpenNavbar(false)}>
                            <LoginIcon sx={{ mr: 1 }} />
                            <ListItemText primary="Login" />
                        </ListItem>
                        <ListItem button component="a" href="https://www.zippyops.com/contact-us" target="_blank" rel="noreferrer">
                            <ContactsIcon sx={{ mr: 1 }} />
                            <ListItemText primary="contact Us" />
                        </ListItem>
                        <ListItem button component="a" href="https://support.zippyops.com/" target="_blank" rel="noreferrer">
                            <Contactus sx={{ mr: 1 }} />
                            <ListItemText primary="Support" />
                        </ListItem>
                        <ListItem button component="a" href="https://www.zippyops.com/" target="_blank" rel="noreferrer">
                            <LibraryBooksIcon sx={{ mr: 1 }} />
                            <ListItemText primary="Docs" />
                        </ListItem>
                        <ListItem button component={Link} to="/products" onClick={() => setOpenNavbar(false)}>
                            <GrainIcon sx={{ mr: 1 }} />
                            <ListItemText primary="Labs Offered" />
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </AppBar>
    );
}
